import { useState, useEffect } from "react";
import { Outlet } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import CookieBanner from "@/components/CookieBanner";
import ScrollToTop from "@/components/ScrollToTop";

export default function Layout() {
  const [cookieOpen, setCookieOpen] = useState(false);

  useEffect(() => {
    const accepted = localStorage.getItem("ope_cookie_ok");
    if (!accepted) setCookieOpen(true);
  }, []);

  const acceptCookies = () => {
    localStorage.setItem("ope_cookie_ok", "1");
    setCookieOpen(false);
  };

  return (
    <div className="min-h-screen flex flex-col bg-background">
      <ScrollToTop />
      <Navbar />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer onOpenCookie={() => setCookieOpen(true)} />
      <CookieBanner open={cookieOpen} onAccept={acceptCookies} />
    </div>
  );
}
